/* eslint-disable no-inner-declarations */

import { IObjectSignature } from 'types';
import i18n from 'i18next';

/* eslint-disable-next-line arrow-body-style */
const isProjectLayerObject = (object: any): object is omjs.ProjectLayerObject => {
    return object instanceof omjs.Project.LayerObject;
};

export namespace ObjectsHelper {

    export interface IModifiedStructureColumn extends omjs.ILayerColumnJSON {
        level?: number;
        isEmpty?: boolean;
        blockId?: number;
    }

    export function getObjectLink(signature: IObjectSignature) {
        let protocol = (window.location.protocol !== 'https:') ? 'http:' : 'https:';
        let port = ~[ '80', '443' ].indexOf(window.location.port) ? '' : window.location.port;

        let path = `${protocol}//${window.location.hostname}${port ? `:${port}` : ''}${window.location.pathname}`;
        let query = `lng=${i18n.language}#/${signature.layer_code}/${signature.object_id}`;

        return `${path}?${query}`;
    }

    export function getObjectName(object:omjs.IObjectJSON | omjs.ProjectLayerObject, config: omjs.ILayerConfig) {
        let field_getter = (field) => {
            if (isProjectLayerObject(object)) {
                return object.get(field);
            } else {
                return object.fields[field];
            }
        };
        if (!config.objectNameAutoChoose && config.objectNameColumnCode) {
            return field_getter(config.objectNameColumnCode);
        } else if (typeof field_getter('name') === 'string') {
            return field_getter('name');
        } else if (typeof field_getter('label') === 'string') {
            return field_getter('label');
        } else {
            return object.id;
        }
    }

    export function getImagesColumnCode(object: omjs.IObjectJSON, config: omjs.ILayerConfig) {
        if (config.mediaFilesEnabled) {
            let files = object.fields[config.mediaFilesColumnCode] as omjs.IObjectFieldValueFile[];
            return files.length ? config.mediaFilesColumnCode : false;
        } else {
            return false;
        }
    }

    export function getFilesColumnCode(
        object: omjs.IObjectJSON,
        structure: omjs.ILayerColumnJSON[],
        config: omjs.ILayerConfig
    ) {
        let images_column = getImagesColumnCode(object, config);
        let file_column = structure.find((c) => {
            let files = object.fields[c.code] as omjs.IObjectFieldValueFile[];
            return (
                c.type === 'file'
                && c.code !== images_column
                && files?.length
            );
        });
        return file_column?.code ?? false;
    }

    export function getFilesColumnCodes(
        object: omjs.IObjectJSON,
        structure: omjs.ILayerColumnJSON[],
        config: omjs.ILayerConfig
    ) {
        let images_column = getImagesColumnCode(object, config);
        return structure.filter((c) => {
            let files = object.fields[c.code] as omjs.IObjectFieldValueFile[];
            return (
                c.type === 'file'
                && c.code !== images_column
                && files?.length
            );
        });
    }

    export function filterStructure(
        structure: omjs.ILayerColumnJSON[],
        config: omjs.ILayerConfig,
        object: omjs.IObjectJSON | false = false,
        keepEmpty: boolean = false
    ): IModifiedStructureColumn[] {
        let exclude_columns = [
            'orbis_id',
            'geom'
        ];

        if (!config.objectNameAutoChoose && config.objectNameColumnCode) {
            exclude_columns.push(config.objectNameColumnCode);
        }

        // Клонируем структуру
        // structure = [...structure];

        let setLevels = function(
            fields: IModifiedStructureColumn[],
            level: number,
            prev_blockId: number
        ) {
            let hasEmptyChildren = true;
            let blockId = prev_blockId;

            fields.forEach((item) => {
                item.isEmpty = true;
                item.level = level;

                // пропускаем поля с файлами
                if (item.type === 'file') {
                    return;
                }

                if (level === 0) {
                    blockId = item.id;
                }

                item.blockId = blockId;

                if (item.type === 'title') {
                    let children = structure.filter(el => el.parent_id === item.id);

                    item.isEmpty = setLevels(children, item.level + 1, blockId);

                    if (!item.isEmpty) {
                        hasEmptyChildren = false;
                    }
                } else if (
                    // Если не передали объект, то считаем что колонка заполнена
                    object === false
                    || (
                        item.code in object.fields
                        && (
                            object.fields[item.code]
                            || object.fields[item.code] === 0
                        )
                    )
                ) {
                    item.isEmpty = false;
                    hasEmptyChildren = false;
                }
            });

            return hasEmptyChildren;
        };
        setLevels(structure.filter(item => item.parent_id === 0), 0, null);

        /* eslint-disable-next-line */
        let casted_structure = structure as IModifiedStructureColumn[];

        return casted_structure.filter(
            item => exclude_columns.indexOf(item.code) === -1 && (!item.isEmpty || keepEmpty)
        );
    }
}
